import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "upload-icon",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M20.5501 11.125C25.0501 11.5125 26.8876 13.825 26.8876 18.8875V19.05C26.8876 24.6375 24.6501 26.875 19.0626 26.875H10.9251C5.3376 26.875 3.1001 24.6375 3.1001 19.05V18.8875C3.1001 13.8625 4.9126 11.55 9.3376 11.1375",
				stroke: "#0066FF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M15 18.7504V4.52539",
				stroke: "#0066FF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M19.1875 7.3125L15 3.125L10.8125 7.3125",
				stroke: "#0066FF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgUploadIcon;
